import React from 'react'
import Footer from '../Footer'
import Header from '../Header'
import MyOrder from '../Profile/MyOrder'

const MyOrderPage = () => {
  return (
    <>
      <Header/>
      <MyOrder/>
      <Footer/>
    </>
  )
}

export default MyOrderPage
